import {
    GET_DROPDOWN_PROJECT_TYPES,
    CREATE_REFERRAL,
    APPROVE_REFERRAL,
    GET_REFERRAL_DETAILS,
    GET_REFERRAL_LIST,
    SITE_CALLING_LIST,
    SITE_CALLING_LOG,
    SITE_CALLING_FORM,
    SITE_CALLING_FILTERS
} from "./type";

const initialState = {
    projectTypes:[],
    saveReferral:[],
    referralApproval:[],
    referralDetails:[],
    referralList:[],
    referralAccountList:[],
    referralCallLog:[],
    referralCallForm:[],
    siteCallingfilters:[]
};

const Referral = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case GET_DROPDOWN_PROJECT_TYPES:
            return {
                ...state,
                projectTypes: payload,
            };
        case CREATE_REFERRAL:
            return {
                ...state,
                saveReferral: payload,
            };
        case APPROVE_REFERRAL:
            return {
                ...state,
                referralApproval: payload,
            };
        case GET_REFERRAL_DETAILS:
            return {
                ...state,
                referralDetails: payload,
            };
        case GET_REFERRAL_LIST:
            return {
                ...state,
                referralList: payload,
            };
        case SITE_CALLING_LIST:
            return {
                ...state,
                referralAccountList: payload,
            };
        case SITE_CALLING_LOG:
            return {
                ...state,
                referralCallLog: payload,
            };
        case SITE_CALLING_FORM:
            return {
                ...state,
                referralCallForm: payload,
            };
        case SITE_CALLING_FILTERS:
            return {
                ...state,
                siteCallingfilters: payload,
            };
        default:
            return {...state};
    }
};

export default Referral;